import { render, staticRenderFns } from "./hirarki.vue?vue&type=template&id=976c4c90"
import script from "./hirarki.vue?vue&type=script&lang=js"
export * from "./hirarki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports